import { useBatches } from "@homesite/hooks";
import type { BatchRow } from "@homesite/ui";
import { BatchExplorerPage } from "@homesite/ui";
import { createRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { rootRoute } from "./__root";

export const batchExplorerRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/batches",
	component: function BatchExplorer() {
		const navigate = useNavigate();
		const [page, setPage] = useState(1);

		const { batches, pagination, loading, error } = useBatches({
			page,
			limit: 20,
		});

		const batchRows: BatchRow[] = batches.map((b) => ({
			merkleRoot: b.merkleRoot,
			recordCount: b.recordCount,
			createdAt: b.createdAt,
			anchored: b.anchored,
			chainName: null,
			txHash: b.txHash ?? null,
			blockNumber: b.blockNumber != null ? Number(b.blockNumber) : null,
			blockTimestamp: b.blockTimestamp ?? null,
		}));

		function handleSelectBatch(root: string): void {
			void navigate({ to: "/batches/$root", params: { root } });
		}

		return (
			<BatchExplorerPage
				batches={batchRows}
				pagination={{
					page: pagination?.page ?? page,
					pageCount: pagination?.totalPages ?? 1,
				}}
				onPageChange={setPage}
				filters={{ chainId: null, anchored: null }}
				onFilterChange={() => {}}
				loading={loading}
				error={error}
				onSelectBatch={handleSelectBatch}
			/>
		);
	},
});
